import { combineReducers } from 'redux';
import locationReducer from './location';
import appReducer from './app';
import siteSearch from '../common/modules/siteSearch';
import {
  createFlopflipReducer,
  FLOPFLIP_STATE_SLICE,
} from '@flopflip/react-redux';

import authReducer, { LOGOUT_SUCCESS } from '../common/modules/auth';
import { reducer as idle } from './redux-idle-monitor';

export const makeRootReducer = (asyncReducers) => {
  const reducer = combineReducers({
    app: appReducer,
    location: locationReducer,
    site_search: siteSearch, // eslint-disable-line
    auth: authReducer,
    [FLOPFLIP_STATE_SLICE]: createFlopflipReducer(),
    idle: idle,
    ...asyncReducers,
  });

  const rootReducer = (state, action) => {
    if (action.type === LOGOUT_SUCCESS) {
      state = undefined;
    }

    return reducer(state, action);
  };

  return rootReducer;
};

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js